import { render, staticRenderFns } from "./SimpleCompanySearch.vue?vue&type=template&id=56635650&"
import script from "./SimpleCompanySearch.vue?vue&type=script&lang=ts&"
export * from "./SimpleCompanySearch.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleCompanySearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports